import React, { useState } from 'react';
import styles from '../assets/scss/RoleTable.module.scss';
import inventoryStyles from '../assets/scss/InventoryManagement/InventoryTable.module.scss';
import settingStyles from '../assets/scss/Settings/Settings.module.scss';
import { FaEdit, FaTrash } from 'react-icons/fa';
import Pagination from '../Components/Common/Pagination';
import { useNavigate } from 'react-router-dom';
import DeleteConfirmModal from '../Components/Common/DeleteConfirmModal';
import { useDeleteRoleMutation, useGetRoleQuery } from '../slices/admin/admin';
import { toast } from 'react-toastify';


const RoleTable = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const [roleFilter, setRoleFilter] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState(null);




    const parsedLimit = parseInt(limit, 10);
    const offset = (currentPage - 1) + 1;

    const parsedIsActive =
        statusFilter === 'true' ? true :
            statusFilter === 'false' ? false :
                undefined;




    const { data: roleDatas, isLoading } = useGetRoleQuery({
        offset,
        limit: parsedLimit,
        isActive: parsedIsActive,
        search: roleFilter,
    });
    const [deleteRole] = useDeleteRoleMutation();

    //console.log(roleDatas,"roleDatas");





    const roles = roleDatas?.result || [];
    const total = roleDatas?.total || 0;
    const totalPages = Math.ceil(total / limit);

    const handleEdit = (role) => {
        navigate('/dashboard/Roles', {
            state: {
                mode: 'edit',
                data: role,
            },
        });

    };

    const handleDelete = (id) => {
        setSelectedRoleId(id);
        setModalOpen(true);
    };


    const confirmDelete = async () => {
        try {
            await deleteRole(selectedRoleId).unwrap();
            toast.success('Role deleted successfully');
        } catch (error) {
            toast.error(error?.data?.message || 'Failed to delete role');
        } finally {
            setModalOpen(false);
        }
    };

    const handleAddRole = () => {
        navigate('/dashboard/Roles');
    };

    if (isLoading) return <div>Loading...</div>;

    return (
        <div className={inventoryStyles.inventoryContainer}>
            <div className={settingStyles.headerRow}>
                <h2 className={settingStyles.header}>Role</h2>
            </div>
            <div className={styles.container}>
                <div className={styles.topBar}>
                    <div className={styles.header}>
                        <div className={styles.filters}>
                            <input
                                type="text"
                                placeholder="Search by role name..."
                                className={styles.input}
                                value={roleFilter}
                                onChange={(e) => {
                                    setRoleFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />

                            <select
                                className={styles.inputs}
                                value={statusFilter}
                                onChange={(e) => {
                                    setStatusFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value=''>All Status</option>
                                <option value='true'>Active</option>
                                <option value='false'>Inactive</option>
                            </select>


                        </div>
                        <div className={styles.filterbtns}>
                            <button
                                className={styles.clearBtn}
                                onClick={() => {
                                    setStatusFilter('');
                                    setRoleFilter('');
                                    setCurrentPage(1);
                                }}
                            >
                                Clear All
                            </button>
                            <button className={styles.addBtn} onClick={handleAddRole}>+ Add Roles</button>
                        </div>

                    </div>

                    <div className={styles.table}>
                        <div className={`${styles.row} ${styles.headerRow}`}>
                            <div><input type="checkbox" /></div>
                            <div>Role Name</div>
                            <div>Status</div>
                            <div>Effective Date</div>
                            <div>Description</div>
                            <div></div>
                        </div>

                        {roles.length > 0 ? (
                            roles.map((role, index) => {
                                const roleClass = styles[role?.roleName?.toLowerCase().replace(/\s+/g, '')] || styles.default;

                                return (
                                    <div className={styles.row} key={role._id || index}>
                                        <div><input type="checkbox" /></div>
                                        <div>
                                            <span className={`${styles.roleBadge} ${roleClass}`}>
                                                {role?.roleName}
                                            </span>
                                        </div>
                                        <div className={role.isActive ? styles.active : styles.inactive}>
                                            {role.isActive ? 'Active' : 'Inactive'}
                                        </div>
                                        <div>{new Date(role.effectiveDate).toLocaleDateString()}</div>
                                        <div>{role.description}</div>
                                        <div className={styles.actions}>
                                            <FaTrash className={styles.icon} onClick={() => handleDelete(role._id)} />
                                            <FaEdit className={styles.icon} onClick={() => handleEdit(role)} />
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className={styles.noData}>No records found</div>
                        )}

                    </div>

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => {
                                setLimit(parseInt(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>

                <DeleteConfirmModal
                    isOpen={isModalOpen}
                    onClose={() => setModalOpen(false)}
                    onConfirm={confirmDelete}
                />
            </div>
        </div>
    );
};

export default RoleTable;

